/**
 * ### Line-art palette
 *
 * The scene is drawn in strokes only. `PAPER` is the section background,
 * used as the fill of solid bodies so that a body occludes the lines behind
 * it without reading as a filled shape. Colour is reserved for the verdict:
 * the red defect box, and the badge on the server that reads green or red.
 */
export const INK = '#e0e3e5';
export const INK_SOFT = '#8e8f9d';
export const INK_FAINT = '#3a3b46';
export const PAPER = '#161617';
export const DEFECT = '#e31b42';
/** Dark red side plane used to keep the NG cube visibly dimensional. */
export const DEFECT_DARK = '#a11034';
export const DEFECT_LIGHT = '#ff6f80';

/** The green the verdict badge fills with while the line is passing units */
export const VERDICT_PASS = '#22c55e';

/** Pale green wash used behind the microphone during an OK inspection */
export const INSPECTION_PASS = '#86efac';

/** Pale red wash used behind the microphone during an NG inspection */
export const INSPECTION_FAIL = '#fda4af';

/**
 * Belt geometry every part lines up with. The top surface is a
 * parallelogram whose back edge sits 40 units to the right of the front,
 * which is what gives the flat drawing its depth. The belt starts and ends
 * far outside the viewBox so it reaches both screen edges on any display;
 * boxes ride it in from the left and out past the right.
 */
export const BELT = {
  start: -2400,
  end: 3400,
  top: 262,
  frontEdge: 322,
  bottom: 352,
  skew: 40,
} as const;
